// Reduced-motion detection and a tiny live subscription helper. Games read this
// to switch their animators into a fast, flash-free reveal path. Pure aside
// from the injectable matchMedia dependency.
const QUERY = '(prefers-reduced-motion: reduce)';
/** Snapshot read of the user's reduced-motion preference. */
export function prefersReducedMotion(win = typeof window !== 'undefined' ? window : {}) {
    try {
        return typeof win.matchMedia === 'function' && win.matchMedia(QUERY).matches;
    }
    catch {
        return false;
    }
}
/**
 * Subscribes to reduced-motion changes. Calls back with the current value
 * immediately and on every change. Returns an idempotent unsubscribe.
 */
export function watchReducedMotion(cb, win = typeof window !== 'undefined' ? window : {}) {
    let mq = null;
    try {
        mq = typeof win.matchMedia === 'function' ? win.matchMedia(QUERY) : null;
    }
    catch {
        mq = null;
    }
    if (!mq) {
        cb(false);
        return () => { };
    }
    const handler = () => cb(Boolean(mq?.matches));
    handler();
    if (mq.addEventListener)
        mq.addEventListener('change', handler);
    else if (mq.addListener)
        mq.addListener(handler);
    let stopped = false;
    return () => {
        if (stopped || !mq)
            return;
        stopped = true;
        if (mq.removeEventListener)
            mq.removeEventListener('change', handler);
        else if (mq.removeListener)
            mq.removeListener(handler);
    };
}
//# sourceMappingURL=motion.js.map